<template>
  <div class="flex inline-flex" v-if="dispositivo.panel_version === 1">
    <div
      class="p-3 rounded-lg cursor-pointer flex inline-flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
      @click="saveData"
      v-if="status === 0"
    >
      <feather-icon icon="SaveIcon" svgClasses="h-4 w-4"/>
      <span class="ml-2 text-base text-primary">Baixar Todos os Dados</span>
    </div>

    <div
      class="p-3 rounded-lg cursor-pointer flex inline-flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
      v-if="status === 1"
    >
      <feather-icon icon="LoaderIcon" svgClasses="h-4 w-4"/>
      <span class="ml-2 text-base text-primary">Aguarde...</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileSalvarDados',
  props: {
    dispositivo: Object,
    relationship: String,
    pagination: Object
  },
  data() {
    return {
      status: 0,
      url: ''
    }
  },
  methods: {
    saveData() {
      const dispositivo = this.dispositivo
      const uid = this.dispositivo.uid
      const relationship = this.relationship

      if (dispositivo.licence.until === null || dispositivo.licence.until === '') {
        this.$vs.notify({
          time: 6000,
          text: 'Somente dispositivos com um plano pago podem baixar os dados.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })

        return
      }

      this.status = 1
      this.$api
      .get(
        `/api/v${dispositivo.panel_version}/mobile/${relationship}/${uid}/download`
      )
      .then((response) => {
        setTimeout(() => {
          this.status = 0
        }, 3000)

        if (response.data.taskId) {
          this.$vs.notify({
            time: 10000,
            text: 'Tarefa agendada. Um e-mail será enviado pra você quando estiver concluído.',
            color: 'success'
          })
        } else {
          window.location.href = response.data
        }
      })
      .catch((error) => {
        this.status = 0
        this.$vs.notify({
          time: 10000,
          text: error.response.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    }
  }
}
</script>
